import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function BillingSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  // Auto-redirect after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/app/livespeak', { replace: true });
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-green-100 dark:bg-green-900 flex items-center justify-center">
            <CheckCircle className="h-8 w-8 text-green-600 dark:text-green-400" />
          </div>
          <CardTitle className="text-2xl">
            Welcome to <span className="text-muted-foreground font-normal">Radiology</span><span className="text-muted-foreground">Live.</span><span className="text-primary">Speak</span> Pro
          </CardTitle>
          <CardDescription>
            Your subscription is now active
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <p className="text-sm text-muted-foreground">
            You now have unlimited access to all templates, reports, and features.
            Your account has been upgraded automatically.
          </p>

          <div className="flex flex-col gap-2">
            <Button onClick={() => navigate('/app/livespeak', { replace: true })} className="w-full">
              Start Reporting
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/app/billing', { replace: true })}
              className="w-full"
            >
              View Subscription
            </Button>
          </div>

          <p className="text-xs text-muted-foreground">
            Redirecting to RadiologyLive.ai Speak in a few seconds...
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
